import React from 'react';
import { AppBar, Toolbar, Typography, IconButton } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { useStyles } from './styles';
import { IPageBarHeader } from './interfaces';

export const PageBarHeader = (props: IPageBarHeader) => {
  const { goBack, title } = props;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          {goBack && (
            <IconButton onClick={goBack} edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
              <ArrowBackIcon />
            </IconButton>
          )}
          <Typography variant="h6" className={classes.title}>
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
  );
};
